import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";

const FormEditClient = () => {
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [vat, setVat] = useState("");
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();
  const { id } = useParams();
  // Access the environment variables
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_KEY = process.env.REACT_APP_API_KEY;

  useEffect(() => {
    const getClientById = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/clients/${id}`,{
          headers: {
            'X-API-Key': API_KEY
          },
        });
        setName(response.data.name);
        setAddress(response.data.address);
        setEmail(response.data.email);
        setPhone(response.data.phone);
        setVat(response.data.vat);
      } catch (error) {
        if (error.response) {
          setMsg(error.response.data.msg);
        }
      }
    };
    getClientById();
  }, [id]);

  const updateClient = async (e) => {
    e.preventDefault();
    try {
      await axios.patch(`${API_BASE_URL}/clients/${id}`, {
        headers: {
            'X-API-Key': API_KEY
        },
        name: name,
        address: address,
        vat: vat,
        email: email,
        phone: phone,
      });
      navigate("/clients");
    } catch (error) {
      if (error.response) {
        setMsg(error.response.data.msg);
      }
    }
  };
  return (
    <div className="container">
      <h1 className="title is-size-5">Edit Client/Customer</h1>
      <div className="card is-shadowless">
        <form onSubmit={updateClient}>
          <p className="has-text-centered">{msg}</p>
          <div className="field">
            <label className="label">Name</label>
            <div className="control">
              <input
                type="text"
                className="input"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Name"
              />
            </div>
          </div>
          <div className="field">
            <label className="label">Address</label>
            <div className="control">
              <input
                type="text"
                className="input"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                placeholder="Address"
              />
            </div>
          </div>
          <div className="field">
            <label className="label">Email</label>
            <div className="control">
              <input
                type="text"
                className="input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
              />
            </div>
          </div>
          <div className="field">
            <label className="label">Phone</label>
            <div className="control">
              <input
                type="text"
                className="input"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Phone"
              />
            </div>
          </div>              
          <div className="field">
            <label className="label">VAT</label>
            <div className="control">
              <input
                type="text"
                className="input"
                value={vat}
                onChange={(e) => setVat(e.target.value)}
                placeholder="VAT"
              />
            </div>
          </div>
          <div className="field">
            <div className="control">
              <Link to="/clients">
              <button className="button is-small is-warning mr-1">
                Cancel
              </button>
              </Link>
              <button type="submit" className="button is-small is-success">
                Update
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormEditClient;
